<template>
  <div class="uploader-image">
    <!-- <div class="uploader-image--main">
      <div class="uploader-image--content">
      </div>
    </div> -->

    <el-upload
      ref="elupload"
      action=""
      :multiple="multiple"
      :drag="drag"
      :accept="accept"
      :show-file-list="false"
      :auto-upload="false"
      :on-change="onChange"
      v-paste="onPaste"
      :enlargeImage="enlargeImage"
    >
      <div slot="trigger"></div>
      <div
        :class="
          'uploader-image--content' +
          (thumbnail && !drag ? ' el-upload-dragger' : '')
        "
      >
        <div v-if="!files.length || !files[0].url">
          <img
            width="80px"
            height="80px"
            src="../images/management-nav-colored.svg"
          />
          <div class="content--text">
            点击这块区域粘贴(Ctrl+V)
            <!-- ，<em @click="handleClick">点击上传</em> -->
          </div>
        </div>
        <img
          class="img-preview"
          v-if="files.length"
          :src="files[0].url"
          @click="isEnlargeImage('0')"
        />
      </div>
      <div class="el-upload__tip" slot="tip">
        只能上传jpg/png文件 <a @click="handleClick">点击上传</a>
      </div>
    </el-upload>
    <div class="uploader-image--thumbnail" flex>
      <!-- <div
        tabindex="0"
        class="el-upload el-upload--picture-card el-upload-list--picture-card"
        v-show="multiple"
        v-for="(file, index) in files"
        :key="index"
      >
        <img :src="file.turl" class="el-upload-list__item-thumbnail" />
      </div> -->

      <div
        tabindex="0"
        class="el-upload el-upload--picture-card el-upload-list--picture-card"
        v-if="files[0] && files[0].turl"
      >
        <img
          :src="files[0].turl ? files[0].turl : ''"
          class="el-upload-list__item-thumbnail"
          @click="isEnlargeImage('1')"
        />
      </div>
    </div>
    <div v-show="false" class="enlarge_image" v-viewer="{ movable: false }">
      <img v-for="(item, index) in enlargeImageList" :src="item" :key="index" />
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import Compressor from "compressorjs";
export default {
  props: {
    // 点击图片是否显示大图
    enlargeImage: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    drag: Boolean,
    accept: {
      type: String,
      default: "image/png,image/jpeg",
    },
    thumbnail: {
      type: Object,
      default: null,
    },
    onAdded: {
      type: Function,
      default: () => {},
    },
    onSuccess: {
      type: Function,
      default: () => {},
    },
    fileList: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      elfiles: [],
      enlargeImageList: [], // 显示大图数组
    };
  },
  computed: {
    elupload() {
      return this.$refs.elupload;
    },
    files() {
      let files = [];
      if (this.elfiles && this.elfiles.length) {
        files = this.elfiles.map((item) => {
          let file = item.raw;
          let url = file ? URL.createObjectURL(file) : "";
          let tfile = null;
          let turl = "";
          if (this.thumbnail) {
            tfile = this.compressor(file);
            turl = tfile ? URL.createObjectURL(tfile) : "";
          }
          return {
            file,
            tfile,
            url,
            turl,
          };
        });
      } else {
        if (this.data) {
          files[0] = this.data;
        }
      }
      return files;
    },
    callbacks() {
      return {
        added: this.onAdded,
      };
    },
  },
  methods: {
    ...mapActions("admin/upload", ["push"]),
    // 点击图片是否显示大图
    isEnlargeImage(type) {
      if (this.enlargeImage) {
        this.enlargeImageList = [];
        if (type === "0") {
          // 主图显示大图
          this.enlargeImageList.push(this.files[0].url);
        } else if (type === "1") {
          // 缩略图显示大图
          this.enlargeImageList.push(this.files[0].turl);
        }
        const viewer = this.$el.querySelector(".enlarge_image").$viewer;
        viewer.show();
      }
    },
    handleClick() {
      if (this.elupload) {
        this.elupload.$refs["upload-inner"].handleClick();
      }
    },
    upFile(file, isThumb) {
      this.push({
        file,
        isThumb,
        ...this.callbacks,
      });
    },
    onChange(file) {
      let originFile = file.raw;
      if (file.status === "ready") {
        if (this.multiple) {
          this.elfiles.push(file);
        } else {
          this.elfiles = [file];
        }
        this.upFile(originFile);
      }
    },
    onPaste({ file }) {
      if (this.multiple) {
        this.elfiles.push({ raw: file });
      } else {
        this.elfiles = [{ raw: file }];
      }
      this.upFile(file);
    },
    compressor(file) {
      let vm = this;
      // const result = await new Promise((resolve, reject) => {
      //   new Compressor(file, {
      //     ...this.thumbnail,
      //     success: (result) => {
      //       let file = new File([result], result.name)
      //       vm.upFile(file, true)
      //       resolve(file)
      //     },
      //     error: reject,
      //   })
      // })
      // return result
      let comp = new Compressor(file, {
        success(result) {
          vm.upFile(new File([result], result.name), true);
        },
        ...this.thumbnail,
      });
      return comp && comp.file ? comp.file : null;
    },
  },
  activated() {
    this.elfiles = [];
  },
};
</script>
<style lang="scss" scoped>
.uploader-image {
  .uploader-image--content {
    display: flex;
    justify-content: center;
    align-items: center;
    .img-preview {
      width: auto;
      height: auto;
      max-width: 360px;
      max-height: 180px;
    }
    .content--text {
      color: #606266;
      font-size: 14px;
      text-align: center;
      em {
        color: #409eff;
        font-style: normal;
      }
    }
  }
  .uploader-image--main {
    background-color: #fff;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    box-sizing: border-box;
    width: 360px;
    height: 180px;
    text-align: center;
    position: relative;
    overflow: hidden;
    cursor: pointer;
    &:hover {
      border-color: #409eff;
      color: #409eff;
    }
    .uploader-image--content {
      margin: 10% 0;
      .content--text {
        color: #606266;
        font-size: 14px;
        text-align: center;
        em {
          color: #409eff;
          font-style: normal;
        }
      }
    }
  }
  .uploader-image--thumbnail {
    margin-top: 20px;
    > div {
      overflow: hidden;
    }
  }
}
.el-upload-list--picture-card {
  .el-upload-list__item-thumbnail {
    height: initial;
  }
}

.el-upload__tip {
  text-align: left;
  a {
    color: #409eff;
    cursor: pointer;
  }
}
</style>
